import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, catchError, finalize, throwError, of } from 'rxjs';
import { CommonMethods } from './common-methods';
import { HeaderComponent } from './layout/header/header.component';
import { LoaderServiceService } from './loader-service.service';

@Injectable()
export class WebServiceInterceptor implements HttpInterceptor {

  constructor(
    private _toastr: ToastrService,
    private headerComponent: HeaderComponent,
    private loaderService: LoaderServiceService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    this.loaderService.hide();
    this.loaderService.show();
    let authreq = request;
    authreq = this.AddTokenheader(request, CommonMethods.getItem("token"));
    return next.handle(authreq).pipe(
      catchError((err: HttpErrorResponse) => {
        let errorMsg = '';
        if (err.status == 0) {
          if (err.error instanceof ProgressEvent) {
            errorMsg = `Unable to connect server!`;
            console.log("Failed to connect to server")
          } else {
            errorMsg = `Error Code: ${err.status},  Message: ${err.message}`;
            console.log("Connection  failed => ", errorMsg)
          }
        } else if (err.status == 403) {
          errorMsg = `Error Code: ${err.status},  Message: ${err.message}`;
          console.log("Unauthorize access =>", errorMsg)
          // this._toastr.error("You don't have permission.");
          return of();
        } else {
          // errorMsg = 'Unknown Error!';
          if (typeof err.error === "object") {
            if (err.error.message) {
              if (typeof err.error.message == 'object') {
                errorMsg = `Error Code: ${err.status},  Message: ${err.message}`;
                console.log("Unknown error=>", errorMsg);
                // this._toastr.error(err.error.message.error);
              } else {
                console.log('====================================');
                console.log(err);
                console.log('====================================');
                if (err.error.message == "Token has expired") {
                  errorMsg = `Error Code: ${err.status},  Message: ${err.message}`;
                  console.log("Token expired: ", errorMsg)
                  this.headerComponent.logout();
                }
                else {
                  errorMsg = `Error Code: ${err.status},  Message: ${err.message}`;
                  console.log(errorMsg);
                  return throwError(() => err);
                }
              }
            } else {
              errorMsg = `Error Code: ${err.status},  Message: ${err.message}`;
              console.log("Unknown error=>", errorMsg);
            }
          } else {
            if (err.error && err.error != "" && err.error != undefined) {
              var error = JSON.parse(err.error);
              if (typeof error === "object") {
                errorMsg = `Error Code: ${err.status},  Message: ${err.message}`;
                console.log("Error include object which parse from json =>", error);
                console.log(errorMsg);
              } else {
                errorMsg = `Error Code: ${err.status},  Message: ${err.message}`;
                console.log("Error without object which parse from json =>", error);
                console.log(errorMsg);
              }
            } else {
              errorMsg = `Error Code: ${err.status},  Message: ${err.message}`;
              console.log("Undefined error =>", errorMsg);
            }
          }
        }
        return throwError(() => err);
      }),
      finalize(() => {
        // Fineal Code
        this.loaderService.hide();
      })
    );
  }

  /**
  * Handling the refresh token
  * @param request: The request
  * @param next:
  */
  // handleRefreshToken(request: HttpRequest<any>, next: HttpHandler) {
  //   let data = {
  //     "accessToken": CommonMethods.getItem("token"),
  //     // "refreshToken": CommonMethods.getItem("refreshToken")
  //   }
  //   CommonMethods.removeItem("token");
  //   // CommonMethods.removeItem("refreshToken");
  //   return this.refreshtokenService.getTokens(data).pipe(
  //     switchMap((res: any) => {
  //       CommonMethods.setItem("token", res.payload.accessToken)
  //       // CommonMethods.setItem("refreshToken", res.payload.refreshToken)
  //       return next.handle(this.AddTokenheader(request, res.payload.accessToken))
  //     }),
  //     catchError((err: HttpErrorResponse) => {
  //       if (err.status == 401) {
  //         log.error("Failed! unauthenticate user: (error status: " + err.status + " message: " + err.error.message);
  //         this.headerComponent.logoutUser();
  //       }
  //       return throwError(err);
  //     })
  //   );
  // }

  /**
  * Adding token in header
  * @param request: The request
  * @param token: The access token 
  * @Return Modified request
  */
  AddTokenheader(request: HttpRequest<any>, token: any) {
    var headerValues: any = {};
    if (token) {
      headerValues['Authorization'] = `Bearer ${token}`;
    }
    return request = request.clone({
      setHeaders: headerValues,
      method: request.method
    });
  }
}

